import React, { PropTypes, Component } from 'react'
import { findProperties } from '../../sources/SearchSource'
import styled from 'styled-components'
import Map from '../../components/Map'
import { Metrics } from '../../Themes'
import { fromJS } from 'immutable'

const Container = styled.section`
  height: calc(100vh - (${Metrics.components.navbarDefault} + ${Metrics
  .components.searchbar}))
  margin-top: calc(${Metrics.components.searchbar} - 1px);
  width: 100vw;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    height: calc(100vh - (${Metrics.components.navbarDefault} + ${Metrics
  .components.mobileSearchBarSize}));
    margin-top: 0;
  }
`

class MapSearch extends Component {
  constructor (props) {
    super(props)
    this.state = {
      properties: [],
      isFetching: false
    }
    this.searchProperties = this.searchProperties.bind(this)
  }

  componentWillMount () {
    this.searchProperties(this.props.settings)
  }

  componentWillReceiveProps (nextProps) {
    if (!fromJS(this.props.settings).equals(fromJS(nextProps.settings))) {
      this.searchProperties(nextProps.settings)
    }
  }

  searchProperties (settings) {
    let query = Object.assign({}, settings, { published: true, sold: false })
    this.setState({ isFetching: true }, () => {
      findProperties({ settings: query, skip: -1, limit: -1 })
        .then(response => {
          this.setState({
            properties: response.data.results,
            isFetching: false
          })
        })
        .catch(error => {
          console.log(error)
        })
    })
  }

  propertyDetail (id) {
    this.props.router.push(`/property/${id}`)
  }

  render () {
    const { propertyDetails } = this.props
    const propList =
      (this.state.properties.length > 0 && this.state.properties) || []

    return (
      <Container>
        <Map
          initialCenter={{
            lat: 0,
            lng: 0
          }}
          places={propList}
          handleSelect={propertyDetails}
        />
      </Container>
    )
  }
}

MapSearch.propTypes = {
  user: PropTypes.object,
  propertyDetails: PropTypes.func,
  router: PropTypes.object,
  settings: PropTypes.object
}

export default MapSearch



// WEBPACK FOOTER //
// ./src/pages/Search/MapSearch.js